module.exports = __webpack_public_path__ + "img/facebook-icon.cd840f432d5d075bf1a5dddaa683ceec.svg";